import React, { useMemo } from "react";

//helpers
import { Case, CaseElse, Switch, useHelpContext } from "@app/contexts";
import {
  selectListReportUi_loadedUi,
  selectListReportUi_tempUi,
} from "@app/state/insider/ui/uiList";
import "@app/style/dx.generic.jurnalKarma1.css";
import "@app/style/dx.generic.teamZebra.css";

import { useAppSelector } from "../../state";
import { ListOfGroups } from "./listOfGroups";
import { ListOfReports } from "./listOfReporst";
import "./lists_common.scss";
//components
import { OptionsAccordion } from "./optionsAccordion";

/* -------------------------------------------------------------------------- */
//todo #10 : not re-render list when selection changes.
//TODO: #8 add command option, selection option and default opened option panel
//TODO: #16 page widh setup (three sizes: portrait, landscape, fullscreen)
//TODO: #17  subscribe and unsubscribe on list load/unload
//TODO: #18 create a field caption dictionary for each list
/* -------------------------------------------------------------------------- */
const _drawerWidth = 750;

export const ListSelectionGroup = () => {
  const theLoadedUi = useAppSelector(selectListReportUi_loadedUi);
  const theSelectingState = useAppSelector(selectListReportUi_tempUi);
  const { showPage } = useHelpContext();
  const { lxGroupId, lxReportId } = useMemo(
    () => theSelectingState,
    [theSelectingState.lxGroupId, theSelectingState.lxReportId]
  );
  const { lxReportId: lxLoadedReportId } = useMemo(
    () => theLoadedUi,
    [theLoadedUi.lxReportId]
  );

  return (
    <div
      id={"listMenuDrawer"}
      style={
        { "--dx-drawer-width": `${_drawerWidth}px` } as React.CSSProperties
      }
      className={"dx-swatch-teamZebraGridTimeSheet"}
    >
      <div id={"listMenu-names"}>
        <ListOfGroups />
      </div>
      <div id={"listMenu-details"}>
        <ListOfReports />
      </div>
      <div id={"listMenu-content"}>
        <Switch value={lxReportId}>
          <Case
            when={[
              (x: number) =>
                x &&
                lxLoadedReportId &&
                +x === +lxLoadedReportId &&
                !showPage?.list,
            ]}
          >
            <OptionsAccordion relativeToActiveReport={"ITSELF"} />
          </Case>
          <Case
            when={[
              (x: number) => x && +x !== +lxLoadedReportId && !showPage?.list,
            ]}
          >
            <OptionsAccordion relativeToActiveReport={"OTHER"} />
          </Case>
          <Case when={[(x: number) => (!x && lxGroupId) || showPage?.list]}>
            <div />
          </Case>
          <Case when={[(x: number) => !(x || lxGroupId)]}>
            <div />
          </Case>
          <CaseElse>
            <div />
          </CaseElse>
        </Switch>
      </div>
    </div>
  );
};

//const ListSelectionGroupmemo = useMemo(()=> ListSelectionGroup, [selectedItemKeys, selectedListByDetails, _drawerWidth]);
